import React, { Component } from 'react';
import FooterImage from '../images/logo_DOTSC_small1.png';
import { Image } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

export class Footer extends Component { 

    render() {

        return (

            <div>
                <div className="ui container"
                     style={{
                        margin: 'auto auto 0 auto'
                     }}
                >
                    <center>
                        <Image size='big' src={FooterImage} style={{ marginRight: '1.5em' }} />
                        <p>
                            * The Upper Great Plains Transportation Institute and North Dakota State
                            University make no representation or warranty, expressed or implied, 
                            regarding the accuracy or reliability of the data displayed.
                        </p>
                    </center>
                </div>
            </div>
        )
    }  
}



// WEBPACK FOOTER //
// ./src/layout/footer.js